const MICROSOFT_ADS_OAUTH_ERROR_MESSAGES: Record<string, string> = {
  google_login_required:
    "This Microsoft Ads account is set up with Google sign-in. Contact Scale Advisors and we'll help connect it.",
  personal_microsoft_login_required:
    "This Microsoft Ads login uses a personal Microsoft account. Try again and sign in with that personal account.",
  work_microsoft_login_required:
    "This Microsoft Ads login uses a work or school Microsoft account. Try again and sign in with that work or school account.",
  different_login_required:
    "This Microsoft Ads account uses a different sign-in. Try again with the Microsoft account you normally use for Microsoft Ads.",
};

export function microsoftAdsOAuthErrorMessage(reason: string | null): string | null {
  return reason ? (MICROSOFT_ADS_OAUTH_ERROR_MESSAGES[reason] ?? null) : null;
}
